(function () {
  function init(root) {
    if (root.dataset.msReady === '1') return;
    root.dataset.msReady = '1';

    var srcEl = root.querySelector('[data-ms-sources]');
    if (!srcEl) return;
    var sources;
    try { sources = JSON.parse(srcEl.textContent); } catch (e) { return; }
    if (!sources || !sources.length) return;

    var jumps = [];
    var jEl = root.querySelector('[data-ms-viewpoints]');
    if (jEl) { try { jumps = JSON.parse(jEl.textContent) || []; } catch (e) { jumps = []; } }

    var stage   = root.querySelector('[data-ms-stage]');
    var img     = root.querySelector('[data-ms-img]');
    var tabsEl  = root.querySelector('[data-ms-tabs]');
    var jumpsEl = root.querySelector('[data-ms-jumps]');
    var caption = root.querySelector('[data-ms-caption]');
    var hint    = root.querySelector('[data-ms-hint]');
    var btnIn   = root.querySelector('[data-ms-zoom="in"]');
    var btnOut  = root.querySelector('[data-ms-zoom="out"]');
    var btnFit  = root.querySelector('[data-ms-zoom="fit"]');

    var current = 0, scale = 1, fitScale = 1, maxScale = 1, tx = 0, ty = 0;
    var ready = false, activeJump = -1, pendingBox = null;

    function frame() { return { w: stage.clientWidth, h: stage.clientHeight }; }
    function nat() {
      return {
        w: img.naturalWidth || sources[current].w || 1,
        h: img.naturalHeight || sources[current].h || 1
      };
    }

    sources.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ms-tab';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.textContent = s.label;
      b.addEventListener('click', function () { load(i, null, -1); });
      tabsEl.appendChild(b);
    });

    function viewIndex(name) {
      for (var i = 0; i < sources.length; i++) {
        if (sources[i].view === name) return i;
      }
      return 0;
    }

    if (jumps.length && jumpsEl) {
      jumps.forEach(function (j, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ms-jump';
        b.setAttribute('aria-pressed', 'false');
        b.textContent = j.label;
        b.addEventListener('click', function () {
          load(viewIndex(j.view || 'full'), j.box || null, i);
        });
        jumpsEl.appendChild(b);
      });
    } else if (jumpsEl) {
      jumpsEl.hidden = true;
    }

    function markTabs() {
      Array.prototype.forEach.call(tabsEl.children, function (b, i) {
        b.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
      if (jumpsEl && jumps.length) {
        Array.prototype.forEach.call(jumpsEl.querySelectorAll('.ms-jump'), function (b, i) {
          b.setAttribute('aria-pressed', i === activeJump ? 'true' : 'false');
        });
      }
    }

    function computeFit() {
      var f = frame(), n = nat();
      fitScale = Math.min(f.w / n.w, f.h / n.h);
      maxScale = Math.max(fitScale, 1.25);
    }

    function clamp() {
      var f = frame(), n = nat();
      var w = n.w * scale, h = n.h * scale;
      tx = w <= f.w ? (f.w - w) / 2 : Math.min(0, Math.max(f.w - w, tx));
      ty = h <= f.h ? (f.h - h) / 2 : Math.min(0, Math.max(f.h - h, ty));
    }

    function draw() {
      clamp();
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      btnOut.disabled = scale <= fitScale + 0.0001;
      btnIn.disabled = scale >= maxScale - 0.0001;
    }

    function fit(keepJump) {
      computeFit();
      scale = fitScale;
      var f = frame(), n = nat();
      tx = (f.w - n.w * scale) / 2;
      ty = (f.h - n.h * scale) / 2;
      if (!keepJump) { activeJump = -1; markTabs(); }
      draw();
    }

    function goToBox(box) {
      computeFit();
      var f = frame(), n = nat();
      var bw = Math.max(0.005, box[2] - box[0]) * n.w;
      var bh = Math.max(0.005, box[3] - box[1]) * n.h;
      scale = Math.min(maxScale, Math.max(fitScale, Math.min(f.w / bw, f.h / bh) * 0.94));
      var cx = (box[0] + box[2]) / 2 * n.w;
      var cy = (box[1] + box[3]) / 2 * n.h;
      tx = f.w / 2 - cx * scale;
      ty = f.h / 2 - cy * scale;
      draw();
      if (hint) hint.classList.add('is-gone');
    }

    function zoomAt(factor, cx, cy) {
      var next = Math.min(maxScale, Math.max(fitScale, scale * factor));
      if (next === scale) return;
      var ix = (cx - tx) / scale, iy = (cy - ty) / scale;
      scale = next;
      tx = cx - ix * scale;
      ty = cy - iy * scale;
      draw();
    }

    function apply() {
      if (pendingBox) { goToBox(pendingBox); pendingBox = null; }
      else { fit(true); }
      markTabs();
    }

    function load(i, box, jumpIdx) {
      activeJump = (typeof jumpIdx === 'number') ? jumpIdx : -1;
      pendingBox = box || null;
      var s = sources[i];
      var changed = (i !== current) || img.getAttribute('src') !== s.url;
      current = i;
      caption.textContent = s.note ? s.label + ' — ' + s.note : s.label;
      if (changed) {
        ready = false;
        img.alt = s.alt || s.label;
        img.src = s.url;
        if (img.complete && img.naturalWidth) { ready = true; apply(); }
      } else {
        apply();
      }
    }

    img.addEventListener('load', function () { ready = true; apply(); });

    btnIn.addEventListener('click', function () { var f = frame(); zoomAt(1.5, f.w / 2, f.h / 2); });
    btnOut.addEventListener('click', function () { var f = frame(); zoomAt(1 / 1.5, f.w / 2, f.h / 2); });
    btnFit.addEventListener('click', function () { fit(false); });

    stage.addEventListener('wheel', function (e) {
      if (!ready) return;
      e.preventDefault();
      var r = stage.getBoundingClientRect();
      zoomAt(e.deltaY < 0 ? 1.16 : 1 / 1.16, e.clientX - r.left, e.clientY - r.top);
      if (hint) hint.classList.add('is-gone');
    }, { passive: false });

    var pointers = new Map(), lastDist = 0, last = null;

    stage.addEventListener('pointerdown', function (e) {
      if (!ready) return;
      stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1) { last = { x: e.clientX, y: e.clientY }; stage.classList.add('is-panning'); }
      if (hint) hint.classList.add('is-gone');
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        var pts = Array.from(pointers.values());
        var dx = pts[0].x - pts[1].x, dy = pts[0].y - pts[1].y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var r = stage.getBoundingClientRect();
        var cx = (pts[0].x + pts[1].x) / 2 - r.left;
        var cy = (pts[0].y + pts[1].y) / 2 - r.top;
        if (lastDist) zoomAt(dist / lastDist, cx, cy);
        lastDist = dist;
        return;
      }
      if (last) {
        tx += e.clientX - last.x;
        ty += e.clientY - last.y;
        last = { x: e.clientX, y: e.clientY };
        draw();
      }
    });

    function endPointer(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) lastDist = 0;
      if (pointers.size === 0) { last = null; stage.classList.remove('is-panning'); }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    stage.addEventListener('keydown', function (e) {
      var step = 60, f = frame(), handled = true;
      if (e.key === 'ArrowLeft') tx += step;
      else if (e.key === 'ArrowRight') tx -= step;
      else if (e.key === 'ArrowUp') ty += step;
      else if (e.key === 'ArrowDown') ty -= step;
      else if (e.key === '+' || e.key === '=') zoomAt(1.4, f.w / 2, f.h / 2);
      else if (e.key === '-' || e.key === '_') zoomAt(1 / 1.4, f.w / 2, f.h / 2);
      else if (e.key === '0') fit(false);
      else handled = false;
      if (handled) { e.preventDefault(); draw(); }
    });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { if (ready) fit(true); }, 150);
    });

    load(0, null, -1);
  }

  function boot() {
    document.querySelectorAll('[data-ms-wm]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
